/**
 * Custom-column cell for `checkbox` columns. A centered boolean toggle;
 * the persisted value is a plain `boolean`.
 */
import { Checkbox } from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';

interface CheckboxCustomCellProps {
  value: boolean;
  onChange: (next: boolean) => void;
}

export function CheckboxCustomCell({ value, onChange }: CheckboxCustomCellProps) {
  const { t } = useTranslation('trackers');

  return (
    <div className="flex w-full items-center justify-center">
      <Checkbox
        checked={value}
        onCheckedChange={(next) => onChange(next === true)}
        onClick={(e) => e.stopPropagation()}
        aria-label={
          value
            ? t('trackersBoard.checkboxCustomCell.checked')
            : t('trackersBoard.checkboxCustomCell.unchecked')
        }
      />
    </div>
  );
}
